import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SIFStrategyState {
  isOpen: boolean;
}

const initialState: SIFStrategyState = {
  isOpen: false,
};

const sifStrategySlice = createSlice({
  name: "sifStrategyModal",
  initialState,
  reducers: {
    openSIFStrategyModal: (state) => {
      state.isOpen = true;
    },

    closeSIFStrategyModal: (state) => {
      state.isOpen = false;
    },
    setSIFStrategyModal: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
  },
});

export const { openSIFStrategyModal, closeSIFStrategyModal, setSIFStrategyModal } = sifStrategySlice.actions;

export default sifStrategySlice.reducer;
